/**
 * リクエストを切り上げてタイムアウトエラーにするまでの時間(ms)
 */
export var REQUEST_TIMEOUT = 30000;
